import { lazy } from "react";
const Products = lazy(
  () => import("../pages/products/Products")
);
const NewProduct = lazy(
  () => import("../pages/products/NewProduct")
);
const ProductView = lazy(
  () => import("../pages/products/ProductView")
);
const EditProduct = lazy(
  () => import("../pages/products/EditProduct")
);
const InventoryManagement = lazy(
  () => import("../pages/products/InventoryManagement")
);

export const productsRoutes = [
    {
        path: "/products",
        component: Products,
      },
      {
        path: "/products/new",
        component: NewProduct,
      },
      {
        path: "/products/:id",
        component: ProductView,
      },
      {
        path: "/products/edit/:id",
        component: EditProduct,
      },
      {
        path: "/products/management",
        component: InventoryManagement,
      },
]